
import { api } from "./useApi";
import {Plan, Ticket} from "../types/Plans";

export const PlansApi = () => ({
    getPlans: async (id_plano?: number) => {
        let response = await api.post("/contrate/listar_planos", {
            id_plano: id_plano
        });
        return response.data as Plan[];
    },

    getTicket: async(ticket: string, plan_id: number): Promise<Ticket | null> => {
        try {
            let response = await api.post("/contrate/validar_cupom", {
                cupom: ticket,
                plano_id: plan_id
            });
            return response.data
        } catch (error: any) {
            if (error.response.status === 404) {
                return null;
            }
            throw error;
        }
    }
});